<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">
          {{ $t('fences.create.subtitle') }}
        </span>
        <h3 class="page-title">{{ $t('fences.create.title') }}</h3>
      </d-col>
    </d-row>

    <puzzle-fences-page/>
  </d-container>
</template>

<script>
import PuzzleFencesPage from '../components/PuzzleFencesPage.vue';

export default {
  name: 'puzzle-fences-create',
  components: {
    PuzzleFencesPage,
  },
};
</script>
